// test2045
(2045 && 0);
